<template>
	<li class="StatsToolbar-stat">
		<!-- @slot slot for the CloStat component -->
		<slot />
	</li>
</template>

<script>
import CloStat from '@/visualizations/CloStat/CloStat.vue';

export default {
	components: { CloStat },
};
</script>

<style lang="scss">
// See CloStatList file for CSS
</style>